import {
  GET_CALL_HISTORY,
  GET_CONTACT,
  GET_PUBLIC_NOTES,
  GET_PRIVATE_NOTES,
  ADD_PRIVATE_NOTE,
  DELETE_PRIVATE_NOTE,
  ADD_PUBLIC_NOTE,
  DELETE_PUBLIC_NOTE,
  GET_CONTACT_NUMBERS,
  GET_CONTACT_STATUT,
  ADD_CONTACT_STATUT,
  UPDATE_CONTACT_STATUT,
  GET_CONTACT_STATUT_MOBILE,
  GET_CONTACT_STATUT_INTERNET,
  ADD_CONTACT_STATUT_INTERNET,
  ADD_CONTACT_STATUT_MOBILE,
  ADD_CONTACT_STATUT_QUALIFICATION,
  GET_CONTACT_STATUT_QUALIFICATION,
  GET_LATEST_CONTACT_STATUT_QUALIFICATION,
  GET_CONTACT_STATUTS_BY_CONTACTID,
  UPDATE_CONTACT_STATUT_MOBILE,
  GET_CONTACT_ADDRESS,
  GET_CONTACT_EMAILS,
  DELETE_CONTACT_EMAIL,
  ADD_SUIVI_STAND_BY,
  UPDATE_CONTACT,
  UPDATE_CONTACT2,
  GET_CONTACTS_BY_OPTIONS,
  ADD_NUMBER,
  DELETE_NUMBER,
  ADD_ADDRESS,
  UPDATE_ADDRESS,
  DELETE_ADDRESS,

  ADD_CONTACT_EMAILS,

  GET_CONTACT_STATUT_MOBILE_BY_USER,
  GET_CONTACT_STATUT_BY_USER,
  UPDATE_FICHE_CONTACT,
  // GET_APPEL_EMETTRE_BY_CONTACT,
  GET_NOTES_ALL_CONTACTS,
  GET_ACTIVITES_BY_CONTACT,
  GET_SUIVI_BY_CONTACT,

  GET_HISTORIQUE_AFFECTATION,
  GET_CONTACT_PARRAINAGE,
  LOADING_STARTED_CONTACT_STATE,

  UPDATE_CALL_STATUS,
  UPDATE_NUMBER,
  // GET_RDV_BY_CONTACT,
} from "../actions/types";
import isEmpty from "is-empty";

function normalizeRefId(ref) {
  if (ref == null) return "";
  if (typeof ref === "object" && ref._id != null) return String(ref._id);
  return String(ref);
}

const initialState = {
  reset: true,
  contact: {},
  contacts: [],

  listParrainage: [],
  rdvByContact: [],
  statuts: [],
  statutsMobile: [],
  statutsInternet: [],
  statutsQualification: [],
  pipelineLeads: [],
  pipelineLeadsMobile: [],
  numeros: [],
  adresses: [],
  emails: [],
  history: [],
  public: [],
  private: [],
  // appelsEmettre: [],
  suiviStandBy: {},
  notesAllContacts: [],
  activites: [],
  prospectionsCommerciale: [],
historiqueAffectation: [],
// chayma 
fichePdf:[],
ficheImage:[],
searchContactByOptions:{
  total:0,
  page:0,
  pages:0,
  data :[]
}
};

export default function (state = initialState, action) {
  switch (action.type) {
    // case GET_RDV_BY_CONTACT:
    //   return {
    //     ...state,
    //     rdvByContact: action.payload
    //   };

    case LOADING_STARTED_CONTACT_STATE:
      return {
        ...state,
        loading: true,
      };
    case LOADING_STARTED_CONTACT_STATE:
      return {
        ...state,
        loading: true,
      };
    case GET_SUIVI_BY_CONTACT:
      return {
        ...state,
        prospectionsCommerciale: action.payload,
      };
    case GET_ACTIVITES_BY_CONTACT:
      return {
        ...state,
        activites: action.payload,
      };
    case UPDATE_CONTACT:
      return {
        ...state,
        contact: action.payload,
      };
      case UPDATE_CONTACT2:
        return {
          ...state,
          contact: {...state.contact,demandeAffectations:action.payload.demandeAffectations},
        };

    //  chayma
    case UPDATE_FICHE_CONTACT:
      return {
        ...state,
        contact: { ...state.contact,
           ficheText: action.payload.ficheText, 
           fichePdf: [...state.fichePdf,action.payload.fichePdf],
           ficheImage:[...state.ficheImage,action.payload.ficheImage]
          }

      };
    case GET_CONTACTS_BY_OPTIONS:  
      return {
        ...state,
        searchContactByOptions: {
          ...state.searchContactByOptions,
          total:action.payload.total,
          pages:action.payload.pages,
          page:action.payload.page,
          data:action.payload.data
        },
      };
    case GET_CONTACT_PARRAINAGE:
      return {
        ...state,
        listParrainage: action.payload,
      };
    case GET_CONTACT_STATUT:
      return {
        ...state,
        statuts: action.payload,
      };
    case GET_CONTACT_STATUT_MOBILE:
      return {
        ...state,
        statutsMobile: action.payload,
      };
      //NEW COMMENT WWW
      
        case GET_CONTACT_STATUT_INTERNET:
      return {
        ...state,
        statutsInternet: action.payload,
      };
      //NEW COMMENT WWW
    case GET_CONTACT_STATUT_BY_USER:
      return {
        ...state,
        pipelineLeads: action.payload,
      };
    case GET_CONTACT_STATUT_MOBILE_BY_USER:
      return {
        ...state,
        pipelineLeadsMobile: action.payload,
      };

    case GET_CALL_HISTORY:
      return {
        ...state,
        history: action.payload,
      };
    case UPDATE_NUMBER:
      return {
        ...state,
        numeros: state.numeros.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                number: action.payload.number,
                description: action.payload.description,
                owner: action.payload.owner,
              }
            : content
        ),
      };
    case UPDATE_CALL_STATUS:
      const index2 = state.history.findIndex(
        (el) => el.number === action.payload.numero.number
      );

      return {
        ...state,
        history: [
          ...state.history,
          (state.history[index2].history = state.history[index2].history.map(
            (element) =>
              element._id === action.payload._id
                ? { ...element,
                   statutAppel: action.payload.statutAppel,
                   approche: action.payload.approche 
                   
                  }
                : element
          )),
        ],
      };

    // return {
    //   ...state,
    //   history: [
    //     ...state.history,
    //     state.history[index2].history =
    //        state.history[index2].history.map(
    //       (element) =>
    //         element._id === action.payload._id
    //           ? { ...element, statutAppel: action.payload.statutAppel }
    //           : element
    //     )
    //   ],
    // };

    case GET_CONTACT:
      return {
        ...state,
        contact: action.payload,
      };
 


    case GET_HISTORIQUE_AFFECTATION:
      return {
        ...state,
        historiqueAffectation: action.payload,
      };
    case GET_CONTACT_NUMBERS:
      return {
        ...state,
        numeros: action.payload,
      };
    case GET_CONTACT_ADDRESS:
      return {
        ...state,
        adresses: action.payload,
      };
       case GET_CONTACT_EMAILS:
      return {
        ...state,
        emails: action.payload,
      };
    case GET_PUBLIC_NOTES:
      return {
        ...state,
        public: action.payload,
      };
    case GET_PRIVATE_NOTES:
      return {
        ...state,
        private: action.payload,
      };
    case GET_NOTES_ALL_CONTACTS:
      return {
        ...state,
        notesAllContacts: action.payload,
      };
    case ADD_PRIVATE_NOTE:
      return {
        ...state,
        private: [action.payload, ...state.private],
      };
    case DELETE_PRIVATE_NOTE:
      state.private.splice(
        state.private.findIndex((e) => e._id === action.payload),
        1
      );
      return {
        ...state,
        private: state.private,
      };
    case ADD_PUBLIC_NOTE:
      return {
        ...state,
        public: [action.payload, ...state.public],
      };
    case DELETE_PUBLIC_NOTE:
      state.public.splice(
        state.public.findIndex((e) => e._id === action.payload),
        1
      );
      return {
        ...state,
        public: state.public,
      };
    case ADD_SUIVI_STAND_BY:
      return {
        ...state,
        suiviStandBy: action.payload,
      };
    case ADD_NUMBER:
      return {
        ...state,
        // Keep full payload (including _id) so the entry can be updated later via updateNumber
        numeros: [...state.numeros, action.payload],
      };

    case DELETE_NUMBER:
      state.numeros.splice(
        state.numeros.findIndex((e) => e._id === action.payload),
        1
      );
      return {
        ...state,
        numeros: state.numeros,
      };
//ADD_CONTACT_EMAILS DELETE_CONTACT_EMAIL
   case ADD_CONTACT_EMAILS:
      return {
        ...state,
         emails: [...state.emails, { addressMail: action.payload.addressMail ,label:action.payload.label}],
      };

  case DELETE_CONTACT_EMAIL:
      state.emails.splice(
        state.emails.findIndex((e) => e._id === action.payload),
        1
      );
      return {
        ...state,
        emails: state.emails,
      };

    case ADD_ADDRESS:
      return {
        ...state,
        adresses: [...state.adresses, action.payload],
      };
    case ADD_CONTACT_STATUT: {
      const addAid = normalizeRefId(action.payload && action.payload.adresseId);
      return {
        ...state,
        statuts: state.statuts.map((content) =>
          normalizeRefId(content.adresseId) === addAid
            ? {
                ...content,
                statuts: [action.payload, ...content.statuts],
              }
            : content
        ),
        pipelineLeads: state.pipelineLeads.map((content) =>
          normalizeRefId(content.adresseId) === addAid
            ? {
                ...content,
                pipelineLeads: [action.payload, ...content.pipelineLeads],
              }
            : content
        ),
      };
    }
   case ADD_CONTACT_STATUT_INTERNET: {
      const addAidInt = normalizeRefId(action.payload && action.payload.adresseId);
      return {
        ...state,
        statutsInternet: state.statutsInternet.map((content) =>
          normalizeRefId(content.adresseId) === addAidInt
            ? {
                ...content,
                statuts: [action.payload, ...content.statuts],
              }
            : content
        ),
      
      };
   }

    case UPDATE_CONTACT_STATUT:
      // console.log(action.payload);
      const index = state.statuts.findIndex(
        (element) => element.adresseId._id === action.payload.adresse._id
      );
      if (index !== -1)
        state.statuts[index].statuts.unshift(action.payload.statuts);
      else
        state.statuts.push({
          adresseId: action.payload.adresse,
          statuts: [action.payload.statuts],
        });
      return {
        ...state,
      };
    case UPDATE_CONTACT_STATUT_MOBILE:
      state.statutsMobile.push({
        // contactId: action.payload.contact,
        statuts: [action.payload.statuts],
      });
      return {
        ...state,
      };
    case ADD_CONTACT_STATUT_MOBILE: {
      const addCid = normalizeRefId(
        action.payload && action.payload.contactId
      );
      return {
        ...state,
        statutsMobile: state.statutsMobile.map((content) =>
          normalizeRefId(content.contactId) === addCid
            ? {
                ...content,
                statuts: [action.payload, ...content.statuts],
              }
            : content
        ),
        pipelineLeadsMobile: state.pipelineLeadsMobile.map((content) =>
          normalizeRefId(content.contactId) === addCid
            ? {
                ...content,
                pipelineLeadsMobile: [
                  action.payload,
                  ...content.pipelineLeadsMobile,
                ],
              }
            : content
        ),
      };
    }
    case UPDATE_ADDRESS:
      return {
        ...state,
        adresses: state.adresses.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                rue: action.payload.rue,
                region: action.payload.region,
                ville: action.payload.ville,
                province: action.payload.province,
                codePostal: action.payload.codePostal,
                description: action.payload.description,
              }
            : content
        ),
      };
    case DELETE_ADDRESS:
      state.adresses.splice(
        state.adresses.findIndex((e) => e._id === action.payload),
        1
      );
      return {
        ...state,
        adresses: state.adresses,
      };

      // case ADD_CONTACT_STATUT_QUALIFICATION:
      //   console.log("state.statutsQualification",state.statutsQualification);
      // return {
      //   ...state,
      //   statutsQualification: state.statutsQualification.map((content) =>
      //     content.adresseId === action.payload.adresseId
      //       ? {
      //           ...content,
      //           statutsQualifications: [action.payload, ...content.statutsQualifications],
      //         }
      //       : content
      //   ),
      
      // };
      case ADD_CONTACT_STATUT_QUALIFICATION:
  return {
    ...state,
    statutsQualification: state.statutsQualification.map((content) =>
      content.adresseId === action.payload.adresseId
        ? {
            ...content,
            statutsQualifications: [
              {
                ...action.payload,
                // On force le nom pour qu'il soit identique aux autres
                statutsQualifications: action.payload.statutQualification 
              },
              ...content.statutsQualifications,
            ],
          }
        : content
    ),
  };

           case GET_CONTACT_STATUT_QUALIFICATION:
      return {
        ...state,
        statutsQualification: action.payload,
      };
      //NEW COMMENT WWW
    default:
      return state;
  }
}
